// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import "@/assets/css/base.css";
import "@/assets/css/share.min.css";
import store from "./store.js";



// import sitemapMiddleware from  '@/utils/sitemap.js'
// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload)

import {
  Pagination,
  Carousel,
  CarouselItem,
  Tabs,
  TabPane,
  Popover,
  Message,
  MessageBox
} from "element-ui";

Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Popover); //和全局注册一样

Vue.component(MessageBox.name, MessageBox); //全局注册一样

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;

// App.get('/sitemap.xml', sitemapMiddleware());

router.afterEach((to, from, next) => {
  if (from.matched[0]) {
    if (
      (from.matched[0].path == "/about-us-list" &&
        to.matched[0].path == "/about-us-list") ||
      (from.matched[0].path == "/tech-service" &&
        to.matched[0].path == "/tech-service")
    ) {
    } else {
      window.scrollTo(0, 0);
    }
  }
});

//将ES6转化成ES5,兼容ie
// import 'babel-polyfill'

import "es6-promise/auto";
import "babel-polyfill";

Vue.config.productionTip = false;
Vue.prototype.axios = axios;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'));
  // }
});



// WEBPACK FOOTER //
// ./src/main.js